import './url-polyfill';

/* eslint-disable */
// 检测浏览器类型
export const getBrowser = () => {
    const ua = window.navigator.userAgent;
    const isIE = window.ActiveXObject != undefined && ua.indexOf('MSIE') != -1;
    const isFirefox = ua.indexOf('Firefox') != -1;
    const isOpera = window.opr != undefined;
    const isChrome = ua.indexOf('Chrome') && window.chrome;
    const isSafari = ua.indexOf('Safari') != -1 && ua.indexOf('Version') != -1;

    if (isIE) {
        return 'IE';
    } else if (isFirefox) {
        return 'Firefox';
    } else if (isOpera) {
        return 'Opera';
    } else if (isChrome) {
        return 'Chrome';
    } else if (isSafari) {
        return 'Safari';
    } else {
        return 'Unkown';
    }
};

// 设置URL查询参数
export const setQuery = ({ url = window.location.href, list = [], force = false }) => {
    let resultUrl = url;

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        list.forEach((item) => {
            const { key, value } = item;

            if (force) {
                searchParams.set(key, value);
            } else if (!searchParams.has(key)) {
                searchParams.append(key, value);
            }
        });

        resultUrl = urlObj.href;
    } catch (e) {
        console.error(e);
    }

    return resultUrl;
};

// 获取URL查询参数
export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 简易的唯一id函数
export const getUuid = (prefix = '') => {
    const tick = Math.floor(Date.now() / 1000);
    const max = 1e9;
    const rand = Math.floor((1 + Math.random()) * max);
    const result = tick.toString(16) + rand.toString(16);

    return prefix ? `${prefix}_${result}` : result;
};
